import { render } from "./BotonOficiosEmbargoPersonaComponent.vue?vue&type=template&id=2d26cec1"
import script from "./BotonOficiosEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./BotonOficiosEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__